<div class="faq-header text-container centered">
  <h3 class="faq-title">{{membershipPricingMock?.faqTranslation[0]?.faqQuestionsSection[0]?.faqHeaderTitle}}</h3>

  <a
    (click)="togglePanelExpanded('faqExpanded', faqAccordion)"
    class="link-expandir"
  >
    {{ faqExpanded ? membershipPricingMock?.faqTranslation[5]?.faqExpandControl?.faqCloseAll : membershipPricingMock?.faqTranslation[5]?.faqExpandControl?.faqExpandAll }}
  </a>
</div>

<div class="text-container pt-0">
  <div class="lista-container">
    <mat-accordion #faqAccordion="matAccordion" multi="true">
      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
              {{membershipPricingMock?.faqTranslation[0]?.faqQuestionsSection[1]?.faqItem1Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[0]?.faqQuestionsSection[1]?.faqItem1Text}}
          </p>
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[0]?.faqQuestionsSection[1]?.faqItem1Text2}}
          </p>
		  <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[0]?.faqQuestionsSection[1]?.faqItem1Text3}}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
              {{membershipPricingMock?.faqTranslation[0]?.faqQuestionsSection[2]?.faqItem2Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
          {{membershipPricingMock?.faqTranslation[0]?.faqQuestionsSection[2]?.faqItem2Text}}
          </p>
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[0]?.faqQuestionsSection[2]?.faqItem2Text2}}
          </p>
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[0]?.faqQuestionsSection[2]?.faqItem2Text3}}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
              {{membershipPricingMock?.faqTranslation[0]?.faqQuestionsSection[3]?.faqItem3Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[0]?.faqQuestionsSection[3]?.faqItem3Text}}
          </p>
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[0]?.faqQuestionsSection[3]?.faqItem3Text2}}
          </p>
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[0]?.faqQuestionsSection[3]?.faqItem3Text3}}
          </p>
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[0]?.faqQuestionsSection[3]?.faqItem3Text4}}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
              {{membershipPricingMock?.faqTranslation[0]?.faqQuestionsSection[4]?.faqItem4Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[0]?.faqQuestionsSection[4]?.faqItem4TextBeforeLink}}
            <a href="mailTo:contato@unhideschool.com">{{membershipPricingMock?.faqTranslation[0]?.faqQuestionsSection[4]?.faqItem4Link}}</a>
             {{membershipPricingMock?.faqTranslation[0]?.faqQuestionsSection[4]?.faqItem4TextAfterLink}}
          </p>
        </div>
      </mat-expansion-panel>


    </mat-accordion>
  </div>
</div>


<br><br>

<div class="faq-header text-container centered">
  <h3 class="faq-title">{{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[0]?.faqHeaderTitle}}</h3>

  <!-- <a
    (click)="togglePanelExpanded('faqExpanded', faqAccordion)"
    class="link-expandir"
  >
    {{ faqExpanded ? "Fechar todos" : "Expandir todos" }}
  </a> -->
</div>

<div class="text-container pt-0">
  <div class="lista-container">
    <mat-accordion #faqAccordion="matAccordion" multi="true">
      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
              {{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[1]?.faqItem1Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[1]?.faqItem1Text}}
          </p>
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[1]?.faqItem1Text2}}
          </p>
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[1]?.faqItem1Text3}}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
               {{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[2]?.faqItem2Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[2]?.faqItem2Text}}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
              {{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[3]?.faqItem3Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[3]?.faqItem3Text}}
          </p>
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[3]?.faqItem3Text2}}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
              {{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[4]?.faqItem4Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[4]?.faqItem4Text}}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
              {{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[5]?.faqItem5Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[5]?.faqItem5Text}}
          </p>
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[5]?.faqItem5Text2}}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
              {{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[6]?.faqItem6Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[6]?.faqItem6Text}}
          </p>
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[6]?.faqItem6Text2}}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
              {{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[7]?.faqItem7Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[7]?.faqItem7Text}}
          </p>
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[1]?.faqPlansPricesQuestionsSection[7]?.faqItem7Text2}}
          </p>
        </div>
      </mat-expansion-panel>


	</mat-accordion>
  </div>
</div>


<br><br>

<div class="faq-header text-container centered">
  <h3 class="faq-title">{{membershipPricingMock?.faqTranslation[2]?.faqBillingQuestionsSection[0]?.faqHeaderTitle}}</h3>

  <!-- <a
    (click)="togglePanelExpanded('faqExpanded', faqAccordion)"
    class="link-expandir"
  >
    {{ faqExpanded ? "Fechar todos" : "Expandir todos" }}
  </a> -->
</div>

<div class="text-container pt-0">
  <div class="lista-container">
    <mat-accordion #faqAccordion="matAccordion" multi="true">
      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
              {{membershipPricingMock?.faqTranslation[2]?.faqBillingQuestionsSection[1]?.faqItem1Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[2]?.faqBillingQuestionsSection[1]?.faqItem1Text}}
          </p>
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[2]?.faqBillingQuestionsSection[1]?.faqItem1Text2}}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
              {{membershipPricingMock?.faqTranslation[2]?.faqBillingQuestionsSection[2]?.faqItem2Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[2]?.faqBillingQuestionsSection[2]?.faqItem2Text}}
          </p>
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[2]?.faqBillingQuestionsSection[2]?.faqItem2Text2BeforeLink}}
            <a href="mailTo:contato@unhideschool.com">{{membershipPricingMock?.faqTranslation[2]?.faqBillingQuestionsSection[2]?.faqItem2Text2Link}}</a>
            {{membershipPricingMock?.faqTranslation[2]?.faqBillingQuestionsSection[2]?.faqItem2Text2AfterLink}}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
               {{membershipPricingMock?.faqTranslation[2].faqBillingQuestionsSection[3].faqItem3Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[2].faqBillingQuestionsSection[3].faqItem3TextBeforeLink}}
            <a href="mailTo:contato@unhideschool.com">{{membershipPricingMock?.faqTranslation[2].faqBillingQuestionsSection[3].faqItem3TextLink}}</a>
            {{membershipPricingMock?.faqTranslation[2].faqBillingQuestionsSection[3].faqItem3TextAfetrLink}}
          </p>
        </div>
      </mat-expansion-panel>


	</mat-accordion>
  </div>
</div>


<br><br>

<div class="faq-header text-container centered">
  <h3 class="faq-title">{{membershipPricingMock?.faqTranslation[3].faqBankSlipQuestionsSection[0].faqHeaderTitle}}</h3>

  <!-- <a
    (click)="togglePanelExpanded('faqExpanded', faqAccordion)"
    class="link-expandir"
  >
    {{ faqExpanded ? "Fechar todos" : "Expandir todos" }}
  </a> -->
</div>

<div class="text-container pt-0">
  <div class="lista-container">
    <mat-accordion #faqAccordion="matAccordion" multi="true">
      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
              {{membershipPricingMock?.faqTranslation[3].faqBankSlipQuestionsSection[1].faqItem1Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[3].faqBankSlipQuestionsSection[1].faqItem1Text}}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
              {{membershipPricingMock?.faqTranslation[3].faqBankSlipQuestionsSection[2].faqItem2Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[3].faqBankSlipQuestionsSection[2].faqItem2Text}}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
               {{membershipPricingMock?.faqTranslation[3].faqBankSlipQuestionsSection[3].faqItem3Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[3].faqBankSlipQuestionsSection[3].faqItem3Text}}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
               {{membershipPricingMock?.faqTranslation[3].faqBankSlipQuestionsSection[4].faqItem4Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[3].faqBankSlipQuestionsSection[4].faqItem4Text}}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
               {{membershipPricingMock?.faqTranslation[3].faqBankSlipQuestionsSection[5].faqItem5Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[3].faqBankSlipQuestionsSection[5].faqItem5Text}}
          </p>
        </div>
      </mat-expansion-panel>


	</mat-accordion>
  </div>
</div>


<br><br>

<div class="faq-header text-container centered">
  <h3 class="faq-title">{{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[0].faqHeaderTitle}}</h3>

  <!-- <a
    (click)="togglePanelExpanded('faqExpanded', faqAccordion)"
    class="link-expandir"
  >
    {{ faqExpanded ? "Fechar todos" : "Expandir todos" }}
  </a> -->
</div>

<div class="text-container pt-0">
  <div class="lista-container">
    <mat-accordion #faqAccordion="matAccordion" multi="true">
      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
              {{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[1].faqItem1Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[1].faqItem1Text}}
          </p>
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[1].faqItem1Text2}}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
              {{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[2].faqItem2Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[2].faqItem2Text}}
          </p>
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[2].faqItem2Text2}}
          </p>
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[2].faqItem2Text3}}
          </p>
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[2].faqItem2Text4}}
          </p>
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[2].faqItem2Text5}}
            <a href="mailTo:contato@unhideschool.com">{{membershipPricingMock?.faqTranslation[4]?.faqCancellationQuestionsSection[2]?.faqItem2TextLink}}</a>
            {{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[2].faqItem2TextAfetrLink}}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
               {{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[3].faqItem3Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[3].faqItem3TextBeforeLink}}
             <a href="mailTo:contato@unhideschool.com">{{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[3].faqItem3TextLink}}</a>
             {{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[3].faqItem3TextAfterLink}}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
               {{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[4].faqItem4Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[4].faqItem4Text}}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="faqExpanded">
        <mat-expansion-panel-header
          [collapsedHeight]="'auto'"
          [expandedHeight]="'auto'"
        >
          <mat-panel-title>
            <div class="faq-title">
               {{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[5].faqItem5Title}}
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="faq-content">
          <p class="faq-text">
            {{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[5].faqItem5TextBeforeLink}} <a href="mailTo:contato@unhideschool.com">{{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[5].faqItem5TextLink}}</a>{{membershipPricingMock?.faqTranslation[4].faqCancellationQuestionsSection[5].faqItem5TextAfterLink}}
          </p>
        </div>
      </mat-expansion-panel>


	</mat-accordion>
  </div>
</div>

